import React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import styles from "./Status.module.scss";

export interface StatusProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: "default" | "compact";
}

const DefaultStatus = ({ children, variant = "default", className, ...props }: StatusProps) => {
  return (
    <div className={clsx(styles.status, className)} data-variant={variant} {...props}>
      {children}
    </div>
  );
};

const Status = createPluggable<StatusProps>("deci.status", DefaultStatus);

export interface StatusGraphicProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  src?: string;
}

const StatusGraphic = ({ children, src, className, ...props }: StatusGraphicProps) => {
  return (
    <div className={clsx(styles.graphic, className)} {...props}>
      {src ? <img src={src} alt="" className={styles.image} /> : children}
    </div>
  );
};
StatusGraphic.displayName = "Status.Graphic";

export interface StatusTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const StatusTitle = ({ children, className, ...props }: StatusTitleProps) => {
  return (
    <div className={clsx(styles.title, className)} {...props}>
      {children}
    </div>
  );
};
StatusTitle.displayName = "Status.Title";

export interface StatusContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const StatusContent = ({ children, className, ...props }: StatusContentProps) => {
  return (
    <div className={clsx(styles.content, className)} {...props}>
      {children}
    </div>
  );
};
StatusContent.displayName = "Status.Content";

export default Object.assign(Status, {
  Graphic: StatusGraphic,
  Title: StatusTitle,
  Content: StatusContent,
});
